import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";

function TotalVoter({ detailDiscussData }: { detailDiscussData: any }) {
  const isClosed = detailDiscussData?.isClosed;
  const totalVotes = detailDiscussData?.totalVotes?.toLocaleString();

  // const [leftTime, setLeftTime] = useState<number>(0);

  // const isClosedRealTime = leftTime <= 0;

  // useEffect(() => {
  //   const calculateSecondsLeft = () => {
  //     const endAt = detailDiscussData?.end_at;
  //     const date = new Date(endAt);
  //     const now = new Date();
  //     const utcOffset = now.getTimezoneOffset() * 60000; // 현재 로컬 시간대의 UTC 오프셋
  //     const utcTime = now.getTime() + utcOffset; // 현재 시간을 UTC로 변환
  //     const koreanOffset = 9 * 60 * 60000; // 한국은 UTC+9 시간대
  //     const koreaTime = new Date(utcTime + koreanOffset); // UTC 시간에 한국 시간 오프셋을 더함
  //     // console.log("koreaTime", koreaTime);

  //     const gap = date.getTime() - koreaTime.getTime();
  //     // console.log("gap", gap);

  //     const hours = Math.floor(gap / (1000 * 60 * 60));
  //     const minutes = Math.floor((gap % (1000 * 60 * 60)) / (1000 * 60));
  //     const seconds = Math.floor((gap % (1000 * 60)) / 1000);

  //     const day = Math.floor(hours / 24);
  //     const hour = hours % 24;
  //     // console.log("day", day);
  //     // console.log("hour", hour);
  //     // console.log("minutes", minutes);
  //     // console.log("seconds", seconds);

  //     setLeftTime(gap);
  //   };

  //   calculateSecondsLeft();

  //   // 1초마다 남은 시간 업데이트
  //   const intervalId = setInterval(calculateSecondsLeft, 1000);

  //   // 컴포넌트 언마운트 시 인터벌 정리
  //   return () => clearInterval(intervalId);
  // }, []);

  //남은 시간
  const formatTime = (gap: number) => {
    const hours = Math.floor(gap / (1000 * 60 * 60));
    const minutes = Math.floor((gap % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((gap % (1000 * 60)) / 1000);

    const day = Math.floor(hours / 24);
    const hour = hours % 24;

    return `${day > 0 ? `${day}일 ` : ""}${String(hour).padStart(
      2,
      "0"
    )}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  return (
    <div className="py-2 px-6 flex flex-col gap-2 items-center">
      <span className={`${TYPO.TYPO7_MD} text-blue40`}>
        {/* {!isClosed
          ? `${totalVotes}명이 투표했어요`
          : `${totalVotes}명 투표 완료`} */}
        {`${totalVotes}명이 투표했어요`}
      </span>
      {/* {!isClosed && !isClosedRealTime ? (
        <span className={`${TYPO.TYPO5_SB} text-gray50`}>
          {`투표 종료까지 ${formatTime(leftTime)}`}
        </span>
      ) : null} */}
    </div>
  );
}

export default TotalVoter;
